<div class="vendor-list-container-main-container">
  <div class="navigation-breadcrumb">
    <span class="breadcrumb-text" (click)="navigateToDashboard()">
      {{ pageTitleEnum.VendorManagement }} / {{ pageTitleEnum.VendorsList }}
    </span>
  </div>

  <div class="vendor-list-container">
    <div class="vendor-rto">
      <div class="rto-circle">
        <div class="circle regular"></div>
        <span class="label">{{ rto.Regular }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle hybrid"></div>
        <span class="label">{{ rto.Hybrid }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle partial-hybrid"></div>
        <span class="label">{{ rto.PartialHybrid }}</span>
      </div>
      <div class="rto-circle">
        <div class="circle remote"></div>
        <span class="label">{{ rto.Remote }}</span>
      </div>
    </div>

    <div class="vendor-search-table-container">
      <div class="vendor-list-search">
        <div class="vendor-title">
          <span>{{ headerTextEnum.VENDORS_LIST }}</span>
        </div>
        <div class="search-bar-container">
          <div class="search-child">
            <emerald-input
              [label]="'Search'"
              [trailingIcon]="'search'"
              (keyup)="searchVendors($event)"
              [value]="filterValue"
              ><emerald-icon
                *ngIf="filterValue?.length && filterValue.length > 0"
                [icon]="'close'"
                (click)="clearInput()"
              ></emerald-icon>
            </emerald-input>
          </div>
          <emerald-dropdown
            [options]="monthOptions"
            [outlined]="true"
            [id]="'single_select'"
            [label]="'Month'"
            [preSelectedValue]="preSelectedValue"
            [preSelectedLabel]="preSelectedLabel"
            (onChange)="onMonthChange($event)"
          ></emerald-dropdown>
        </div>
      </div>

      <div class="vendor-list-table">
        <ng-container *ngIf="displayData?.length; else noDataTemplate">
          <emerald-datatable
            [columnDefs]="columnDefs"
            [rowData]="displayData"
            [paginationParams]="paginationParams"
            [customCellTemplate]="{
              vendorName: customVendorNameColumn,
              rto: customRtoColumn,
            }"
          >
          </emerald-datatable>
        </ng-container>
        <ng-template #noDataTemplate>
          <section class="records-container" aria-label="Records section">
            <div class="empty-state">
              <ng-container *ngIf="isDataLoaded">
                <h2 class="empty-state-title">{{ errorMsg }}</h2>
              </ng-container>
              <img
                [src]="imageSrc"
                alt="No records illustration"
                class="empty-state-image"
              />
            </div>
          </section>
        </ng-template>
        <ng-template
          #customVendorNameColumn
          let-level="level"
          let-eachRow="eachRow"
        >
          <a
            class="vendor-name"
            (click)="
              navigateToVendorProfile(eachRow.vendorId, eachRow?.vendorName)
            "
            >{{ eachRow?.vendorName }}</a
          >
        </ng-template>

        <ng-template #customRtoColumn let-eachRow="eachRow">
          <section class="progress-bar">
            <ng-container *ngFor="let rto of rtoSegments">
              <div
                class="segment"
                [ngClass]="rto.class"
                (click)="navigateToContractorList(eachRow.vendorId, rto.label)"
                [title]="rto.label + ': ' + eachRow[rto.key] + '%'"
              >
                <div class="segment-bar" [style.width.%]="eachRow[rto.key]"></div>
                <span class="segment-label">{{ eachRow[rto.key] }}%</span>
              </div>
            </ng-container>
          </section>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<app-modal-wrapper *ngIf="showVendorProfile" [showModal]="showVendorProfile">
  <app-vendor-profile
    [vendorEmployeeData]="selectedVendor"
    (close)="showVendorProfile = false; selectedVendor = null"
  ></app-vendor-profile>
</app-modal-wrapper>
